import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

function mobileNumber (value) {
  try {
        if (typeof value !== 'undefined' && value) {
           if (i18n.locale === 'bn') {
               return '০' + i18n.n(value, { useGrouping: false })
           } else {
            return '0' + i18n.n(value, { useGrouping: false })
        }
        }
  } catch (e) {
        return value
    }
}
const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center' }
      )
      pdfContent.push(
        { text: reportTitle, style: 'header', alignment: 'center' }
      )
      let allRows = []
      if (data.print_status === 1) {
        allRows = [
          [
            { text: vm.$t('rehabilitation_management.resident_name'), bold: true, style: 'td', alignment: 'left' },
            { text: (i18n.local === 'bn') ? data.name_bn : data.name, style: 'td', alignment: 'left' },
            { text: vm.$t('institute_manangement.mobile_number'), bold: true, style: 'td', alignment: 'left' },
            { text: mobileNumber(data.contact_no), style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('institute_manangement.registration_id'), bold: true, style: 'td', alignment: 'left' },
            { text: data.registration_id, style: 'td', alignment: 'left' },
            { text: vm.$t('institute_manangement.organization'), bold: true, style: 'td', alignment: 'left' },
            { text: (i18n.local === 'bn') ? data.org_name_bn : data.org_name, style: 'td', alignment: 'left' }
          ]
        ]
      } else {
        allRows = [
          [
            { text: vm.$t('institute_manangement.guardian_name'), bold: true, style: 'td', alignment: 'left' },
            { text: (i18n.local === 'bn') ? data.legal_guardian_bn : data.legal_guardian, style: 'td', alignment: 'left' },
            { text: vm.$t('rehabilitation_management.resident_name'), bold: true, style: 'td', alignment: 'left' },
            { text: (i18n.local === 'bn') ? data.name_bn : data.name, style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('institute_manangement.registration_id'), bold: true, style: 'td', alignment: 'left' },
            { text: data.registration_id, style: 'td', alignment: 'left' },
            { text: vm.$t('institute_manangement.organization'), bold: true, style: 'td', alignment: 'left' },
            { text: (i18n.local === 'bn') ? data.org_name_bn : data.org_name, style: 'td', alignment: 'left' }
          ]
        ]
      }
        pdfContent.push({
            table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: allRows
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
        })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
          content: pdfContent,
          pageSize: 'A4',
          pageOrientation: 'portrait',
          watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
          styles: {
            th: {
              border: 0,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            th1: {
              border: 0,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            td: {
              border: 1,
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            td2: {
                border: 0,
                fontSize: 10,
                alignment: 'center'
              },
            header: {
              border: 0,
              margin: [0, 1, 0, 15],
              fontSize: 14,
              alignment: 'center'
            },
            left_header: {
              margin: [4, 0, 0, 10]
            },
            oderDetails: {
              border: true,
              fontSize: 14
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
                border: 0,
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 5]
              },
            address2: {
              border: 0,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            left_logo: {
              border: 0,
              margin: [5, 0, 0, 5]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
